export default __webpack_public_path__ + "static/media/Kategori Produk-KITCHEN QUEEN-2.3e6ae6f8.jpg";